/**
 * Client-side types (mirrors server types for consistency)
 */

export type SkillLevel = 1 | 2 | 3;

export interface Player {
  id: string;
  name: string;
  skill: SkillLevel;
  totalPoints: number;
  wins: number;
  timesSatOut: number;
  partnerHistory: string[]; // Converted to array for JSON serialization
  opponentHistory: string[];
}

export type TournamentFormat = 'rotating' | 'swiss' | 'fixed-team' | 'balanced';

export interface TournamentConfig {
  name: string;
  format: TournamentFormat;
  courts: number;
  rounds: number;
  targetScore: number;
  winBy: number;
}

export interface Tournament {
  id: string;
  config: TournamentConfig;
  players: Player[];
  schedule: Round[];
  isComplete: boolean;
  createdAt: string;
}

export interface Team {
  player1Id: string;
  player2Id: string;
}

export interface Match {
  id: string;
  roundIndex: number;
  courtIndex: number;
  teamA: Team;
  teamB: Team;
  teamAScore?: number;
  teamBScore?: number;
  isComplete: boolean;
  sittingOutPlayerIds?: string[];
}

export interface Round {
  index: number;
  matches: Match[];
  sittingOutPlayerIds: string[];
  isComplete: boolean;
}

export interface LeaderboardEntry {
  playerId: string;
  playerName: string;
  skill: SkillLevel;
  wins: number;
  losses: number;
  totalPoints: number;
  pointsAgainst: number;
  pointDifferential: number;
  matchesPlayed: number;
  timesSatOut: number;
  teamWins?: number;
  teamLosses?: number;
}

export const STORAGE_KEY = 'pickleball_tournament_data';